/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Sex_FemaleInputs */

const en_us2_body_assessment_sex_female = /** @type {(inputs: Body_Assessment_Sex_FemaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Female`)
};

const pt_br2_body_assessment_sex_female = /** @type {(inputs: Body_Assessment_Sex_FemaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feminino`)
};

const es_419_body_assessment_sex_female = /** @type {(inputs: Body_Assessment_Sex_FemaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Femenino`)
};

const pt_pt2_body_assessment_sex_female = /** @type {(inputs: Body_Assessment_Sex_FemaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feminino`)
};

const fr_fr2_body_assessment_sex_female = /** @type {(inputs: Body_Assessment_Sex_FemaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Féminin`)
};

const de_de2_body_assessment_sex_female = /** @type {(inputs: Body_Assessment_Sex_FemaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weiblich`)
};

const it_it2_body_assessment_sex_female = /** @type {(inputs: Body_Assessment_Sex_FemaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Femminile`)
};

/**
* | output |
* | --- |
* | "Female" |
*
* @param {Body_Assessment_Sex_FemaleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_sex_female = /** @type {((inputs?: Body_Assessment_Sex_FemaleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Sex_FemaleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_sex_female(inputs)
	if (locale === "es-419") return es_419_body_assessment_sex_female(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_sex_female(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_sex_female(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_sex_female(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_sex_female(inputs)
	return en_us2_body_assessment_sex_female(inputs)
});
export { body_assessment_sex_female as "body-assessment.sex_female" }